import { render, staticRenderFns } from "./RideReview.vue?vue&type=template&id=bf6188fa&scoped=true&"
import script from "./RideReview.vue?vue&type=script&lang=js&"
export * from "./RideReview.vue?vue&type=script&lang=js&"
import style0 from "./RideReview.vue?vue&type=style&index=0&id=bf6188fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6188fa",
  null
  
)

export default component.exports